<template>
  <v-layout column>
    <v-card class="intro-dark mx-5">
      <v-card-text class="text-center white--text">
        <mrx-translation token="app.upload.save.instructions"></mrx-translation>
        <br/>
        <v-btn
          id="save-results"
          block
          x-large
          @click.once="save"
        >
          <mrx-translation token="app.upload.save.button"></mrx-translation>
        </v-btn>
        <br/><br/>
        <mrx-translation token="app.upload.discard.instructions"></mrx-translation>
        <br/>
        <v-btn
          id="discard-results"
          class="secondary-btn"
          block
          x-large
          outlined
          @click="confirmDiscardDialog=true"
        >
          <mrx-translation token="app.upload.discard.button"></mrx-translation>
        </v-btn>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="confirmDiscardDialog"
      overlay-color=primaryblue
      overlay-opacity="0.9"
      max-width="400px"
    >
      <v-card class="intro-dark pb-2">
        <v-card-title class="justify-center dialog-title">
          <mrx-translation token="app.dialog.discard_title"></mrx-translation>
        </v-card-title>
        <v-card-text
          class="white--text intro-body text-center modal-text"
          style="line-height: 1.2em"
        >
          <mrx-translation token="app.dialog.discard_warning"></mrx-translation>
        </v-card-text>
        <v-card-actions class="justify-space-around pt-0">
          <v-row no-gutters class="flex xs6 pe-2">
            <v-btn
              id="cancel-discard"
              class="cancel-btn"
              outlined
              block
              @click="discard(false)"
            >
              <mrx-translation token="app.dialog.button.no"></mrx-translation>
            </v-btn>
          </v-row>
          <v-row no-gutters class="flex xs6 ps-2">
            <v-btn
              id="confirm-discard"
              class="modal-btn"
              block
              @click="discard(true)"
            >
              <mrx-translation token="app.dialog.button.yes_discard"></mrx-translation>
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import { mapActions } from 'vuex'
  import languageLogic from '@/mixins/languageLogic'

  export default {
    mixins: [languageLogic],
    name: 'Upload',
    data() {
      return {
        confirmDiscardDialog: false
      }
    },
    mounted() {
      if (this.$store.state.settings.engagements_features?.autoCollectTracks) {
        this.save()
      }

    },
    methods: {
      save() {
        this.$store.commit('v4/track/set', { clickedSave: true })
        
        const startTime = Date.now()
        
        this.$track(this.$analyticsEvents.ENCOUNTER_SAVE_STARTED, {
          component: 'Upload',
          is_auto_collect: !!this.$store.state.settings.engagements_features?.autoCollectTracks
        })
        this.$store.dispatch('v4/stream/send')
        this.$store.dispatch('v4/collect/send')
        this.$store.state.recordsInQueue = this.$store.state.recordsInQueue + 1
        this.$track(this.$analyticsEvents.ENCOUNTER_SAVED, {
          component: 'Upload',
          is_auto_collect: !!this.$store.state.settings.engagements_features?.autoCollectTracks,
          save_duration_ms: Date.now() - startTime,
          records_in_queue: this.$store.state.recordsInQueue
        })
        this.next()
      },
      discard(choice) {
        this.confirmDiscardDialog = false;
        if (choice){
          this.$track(this.$analyticsEvents.ENCOUNTER_DISCARDED, {
            component: 'Upload'
          })
          this.next()
        } else {
          this.$track(this.$analyticsEvents.ENCOUNTER_DISCARD_CANCELLED, {
            component: 'Upload'
          })
        }
      },
      ...mapActions({ previous: 'v4/navigate/previous', next: 'v4/navigate/next' })
    }
  }
</script>


<style scoped>
  .secondary-btn {
    background-color: transparent !important;
  }

  .dialog-title {
    font-weight: 600 !important;
    font-size: 18px !important;
    line-height: 1.1em;
  }
</style>
